export default (d) => JSON.parse(JSON.stringify(d))
